var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterGrpOnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-table-filter-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 40,
    height: 40,
    rx: 4,
    fill: "rgba(255,0,0,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "grp-filter-on",
    d: "M18.41,32a1.473,1.473,0,0,1-1.5-1.5v-9L7.948,10.063a1.135,1.135,0,0,1-.15-1.35A1.232,1.232,0,0,1,8.96,8h21.9a1.232,1.232,0,0,1,1.162.712,1.135,1.135,0,0,1-.15,1.35L22.91,21.5v9a1.473,1.473,0,0,1-1.5,1.5Zm1.5-10.35,9-11.4h-18ZM19.91,21.65Z",
    transform: "translate(0.358)",
    fill: "rgba(0,0,0,0.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGrpOnIcon);
export default __webpack_public_path__ + "static/media/Filter-grp-on-icon.7aa5a9af9f8d9105cbbcf2b360f2e686.svg";
export { ForwardRef as ReactComponent };